<app-viewonly-select-mode
    [options]="states"
    [value]="selectedState"
    keyname="value"
    valuename="value"
>
</app-viewonly-select-mode>
<select [(ngModel)]="selectedState" 
    (keydown)="checkAndSetClass($event)"
    (change)="changeState($event)" 
    (focus)="checkAndSetClass($event)"
    (input)="checkAndSetClass($event)"
    (blur)="checkAndSetClass($event)"
    [required]="required !== undefined"
>
    <option *ngIf="default !== undefined" value="">Choose a state</option>
    <option 
        [value]="state.value" 
        *ngFor="let state of states" 
    >
        {{ state.value }}
    </option>
</select>